import React, { useState, useEffect, useRef } from 'react';
import './Navbar.scss';
import logo from '../../assets/icons/logo.svg';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navbarCollapseRef = useRef(null);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  useEffect(() => {
    if (isMobile && window.bootstrap) {
      const dropdownElements = document.querySelectorAll('.mobile-dropdown');
      dropdownElements.forEach(dropdown => {
        const bsDropdown = new window.bootstrap.Dropdown(dropdown);

        if (isMobile) {
          setTimeout(() => {
            bsDropdown.show();
          }, 100);
        }
      });
    }
  }, [isMobile]);

  const navbarItems = [
    {
      name: 'Strona Główna',
      path: '/',
    },
    {
      name: 'O Nas',
      path: '/o-nas',
      dropdown: [
        {
          name: 'Nasz zespół',
          path: '/o-nas/#zespół',
        },
        {
          name: 'Galeria',
          path: '/o-nas?#galeria',
        },
      ],
    },
    {
      name: 'Oferta',
      path: '/oferta',
    },
    {
      name: 'Cennik',
      path: '/cennik',
    },
    {
      name: 'Kontakt',
      path: '/kontakt',
    },
  ];

  const handleLinkClick = () => {
    if (isMobile && navbarCollapseRef.current && window.bootstrap) {
      const bsCollapse = window.bootstrap.Collapse.getInstance(navbarCollapseRef.current);
      if (bsCollapse) {
        bsCollapse.hide();
      }
    }
  };

  return (
    <div className='main-nav'>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="zlota centrum zdrowia logo" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div 
              className="collapse navbar-collapse" 
              id="navbarSupportedContent"
              ref={navbarCollapseRef}
            >
            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
             {
                  navbarItems.map(navSingle =>
                    navSingle.dropdown ? (
                      <li key={navSingle.name} className={`nav-item dropdown ${isMobile ? 'show' : ''}`}>
                        <Link
                          className={`nav-link dropdown-toggle ${isMobile ? 'dropdown-expanded' : ''}`}
                          to={isMobile ? '#' : navSingle.path}
                          role="button"
                          data-bs-toggle={isMobile ? null : "dropdown"}
                          aria-expanded={isMobile ? "true" : "false"}
                          onClick={(e) => {
                            if (isMobile) {
                              e.preventDefault();
                            }
                          }}
                        >
                          {navSingle.name}
                        </Link>
                        <ul className={`dropdown-menu ${isMobile ? 'show' : ''}`}>
                          {navSingle.dropdown.map(dropItem => (
                            <li key={dropItem.name}>
                              <Link
                                className="dropdown-item"
                                to={dropItem.path}
                                onClick={handleLinkClick}
                              >
                                {dropItem.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ) : (
                      <li key={navSingle.name} className="nav-item">
                        <Link
                          className="nav-link"
                          to={navSingle.path}
                          onClick={handleLinkClick}
                        >
                          {navSingle.name}
                        </Link>
                      </li>
                    )
                  )
                }
              </ul>
              <div className="theme-btn">
                <Link
                  target='_blank'
                  to="https://mydr.pl/welcome"
                  onClick={handleLinkClick}
                >
                  Umów wizytę
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
